export default __webpack_public_path__ + "static/media/Mom.be988559.jpeg";